import React, { useState } from 'react';
import {
  Modal,
  View,
  Text,
  TextInput,
  TouchableOpacity,
  FlatList,
  Image,
  StyleSheet,
  Platform,
  Dimensions,
  ActivityIndicator,
} from 'react-native';

const { width, height } = Dimensions.get('window');

const SelectClientModal = ({ visible, onClose, onSelectClient, clients = [], loading = false }) => {
  const [searchQuery, setSearchQuery] = useState('');

  const filteredClients = clients.filter(client =>
    (client.parentName || '').toLowerCase().includes(searchQuery.toLowerCase()) ||
    (client.parentId || '').toLowerCase().includes(searchQuery.toLowerCase())
  );

  const renderClientItem = ({ item }) => (
    <TouchableOpacity style={styles.clientRow} onPress={() => {
      if (onSelectClient) onSelectClient(item);
      onClose();
    }}>
      <View style={styles.clientInfo}>
        <Text style={styles.clientName}>{item.parentName}</Text>
        <Text style={styles.clientId}>{item.parentId}</Text>
      </View>
    </TouchableOpacity>
  );

  return (
    <Modal
      transparent
      visible={visible}
      animationType="fade"
      onRequestClose={() => {}}
    >
      <View style={styles.modalOverlay}>
        <View style={styles.modalContent} onStartShouldSetResponder={() => true} onClick={(e) => e.stopPropagation()}>
          {/* Header */}
          <View style={styles.headerContainer}>
            <Text style={styles.title}>Select Client</Text>
          </View>

          {/* Search Input */}
          <TextInput
            style={styles.searchInput}
            placeholder="Search clients..."
            placeholderTextColor="#aaa"
            value={searchQuery}
            onChangeText={setSearchQuery}
          />

          {/* Client List */}
          <FlatList
            style={{ flex: 1 }}
            data={filteredClients}
            keyExtractor={item => item.parentId}
            renderItem={renderClientItem}
            contentContainerStyle={styles.listContainer}
            showsVerticalScrollIndicator={false}
            keyboardShouldPersistTaps="handled"
            ListEmptyComponent={
              loading ? (
                <ActivityIndicator size="large" color="#A6CE39" style={{ marginTop: 20 }} />
              ) : (
                <Text style={styles.emptyText}>No clients found.</Text>
              )
            }
          />
        </View>
      </View>
    </Modal>
  );
};

const styles = StyleSheet.create({
  modalOverlay: {
    flex: 1,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    justifyContent: 'center',
    alignItems: 'center',
  },
  modalContent: {
    width: width * 0.9,
    maxWidth: 400,
    height: 500, // fixed height
    backgroundColor: '#ffffff',
    borderRadius: 12,
    padding: 20,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.25,
    shadowRadius: 3.84,
    elevation: 5,
  },
  headerContainer: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'relative',
    marginBottom: 20,
  },
  title: {
    fontSize: 20,
    fontFamily: Platform.OS === 'android' ? 'FacebookSansRegular' : 'Facebook Sans',
    fontStyle: 'normal',
    fontWeight: 'bold',
    color: '#000000',
  },
  closeButton: {
    position: 'absolute',
    right: 0,
    padding: 5,
  },
  closeButtonText: {
    fontSize: 20,
    color: '#999',
    fontWeight: 'bold',
  },
  searchInput: {
    height: 45,
    borderWidth: 1,
    borderColor: '#e0e0e0',
    borderRadius: 8,
    paddingHorizontal: 15,
    marginBottom: 15,
    fontSize: 16,
    fontFamily: Platform.OS === 'android' ? 'FacebookSansRegular' : 'Facebook Sans',
    backgroundColor: '#f9f9f9',
    color: '#333',
  },
  listContainer: {
    paddingBottom: 10,
  },
  clientRow: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingVertical: 12,
    borderBottomWidth: 1,
    borderBottomColor: '#f0f0f0',
  },
  clientInfo: {
    flexDirection: 'column',
    justifyContent: 'center',
  },
  clientName: {
    fontSize: 16,
    fontFamily: Platform.OS === 'android' ? 'FacebookSansRegular' : 'Facebook Sans',
    color: '#333333',
    fontWeight: '500',
  },
  clientId: {
    fontSize: 14,
    fontFamily: Platform.OS === 'android' ? 'FacebookSansRegular' : 'Facebook Sans',
    color: '#888',
    marginTop: 2,
  },
  emptyText: {
    textAlign: 'center',
    color: '#999',
    marginTop: 20,
    fontFamily: Platform.OS === 'android' ? 'FacebookSansRegular' : 'Facebook Sans',
  },
});

export default SelectClientModal;
